// Copyright (c) 2020 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import actions from '../../../actions-list';
import {getFavorites} from '../../../../shared/repositories';

export const readFavorites = userId =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getFavorites(userId);

            dispatch({
                data,
                type: actions.READ_FAVORITES
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/shared/components/favorites/action-creators/read-favorites.js